module.exports = __webpack_public_path__ + "img/4.6e18d6ce.png";